import classNames from "classnames"
import React, { ReactElement } from "react"

import viewManager from "~/shared/util/viewManager"

import "./PreviewBanner.less"

export default function PreviewBanner(): ReactElement | null {
  const previewId = viewManager.get("preview") as string | undefined
  const previewStatus = viewManager.get("previewStatus") as string | undefined
  const failed = previewStatus === "failed"

  if (!previewId) {
    return null
  }

  return (
    <div className={classNames("PreviewBanner", { "PreviewBanner--failed": failed })}>
      <span>{failed ? "Preview failed to load" : "Preview Mode"}</span>
      <a href="/_preview/exit" className="PreviewBanner__link">
        Exit Preview
      </a>
    </div>
  )
}
